<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <li class="active">外部ログインサービス利用設定</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
            <h3>外部ログインサービス利用設定</h3>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <div class="alert alert-danger" v-html="errorMessage" v-if="errorMessage">
                </div>
                <div class="alert alert-success" v-html="sucessStatus" v-if="sucessStatus">
                </div>
                <!-- PAGE CONTENT BEGINS -->
                <div class="col-xs-12">
                    <div class="clearfix">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>Onelogin でログイン</b></div>
                        <div class="profile-info-value">
                            <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="!isFederatedLoginService" v-model="oneloginLoginService.isValid" type="checkbox">
                            <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px">メタデータURL</div>
                        <div class="profile-info-value" style="width:450px;border:0px solid">
                          <input type="text" class="form-control input-sm" :disabled ="!isFederatedLoginService" v-model="oneloginLoginService.metadataUrl" placeholder="メタデータURL">
                        </div>
                      </div>
                    </div>
                    <div class="clearfix" style="margin-bottom: 10px;">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>Google でログイン</b></div>
                        <div class="profile-info-value">
                            <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="!isFederatedLoginService" v-model="googleLoginService.isValid" type="checkbox">
                            <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix" style="margin-bottom: 10px;">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>AppleID でログイン</b></div>
                        <div class="profile-info-value">
                            <input name="switch-field-1" class="ace ace-switch ace-switch-4" :disabled ="!isFederatedLoginService" v-model="appleIdLoginService.isValid" type="checkbox">
                            <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <div class="profile-info-row">
                        <button class="btn btn-info" :disabled="!allowSubmit" type="button" @click="saveConfig()">設定を保存</button>
                      </div>
                    </div>
                </div>
                <!-- PAGE CONTENT ENDS -->
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <a href="javascript:void(0)" class="float" id="menu-share">
    <i class="fa fa-plus my-float"></i>
    </a>
    <ul class="add_btn_list">
      <!-- <li>
        <router-link :to="{ name: 'relation-user-federated-login-service'}" class="adduserExport">
          <i class="ace-icon fa fa-users my-float"></i>
        </router-link>
        <div class="label-container">
          <div class="label-text">ログインユーザー登録</div>
          <i class="fa fa-play label-arrow"></i>
        </div>
      </li> -->
      <li>
        <router-link :to="{ name: 'relation-user-federated-login-service'}" class="adduserExport">
          <i class="ace-icon fa fa-users my-float"></i>
        </router-link>
        <div class="label-container-export" style="top:180px">
          <div class="label-text">ログインユーザー登録</div>
          <i class="fa fa-play label-arrow"></i>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import * as Config from '../../config'
export default {
  data () {
    return {
      errorMessage: '',
      sucessStatus: '',
      initFinish: false,
      OwnerFederatedLoginService: [],
      federatedLoginServices: [],
      googleLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        isValid: false,
        name: 'Google',
        oldIsValid: false
      },
      oneloginLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        isValid: false,
        name: 'Onelogin',
        oldIsValid: false
      },
      appleIdLoginService: {
        relationId: '',
        federatedLoginServiceId: '',
        metadataUrl: '',
        isValid: false,
        name: 'Apple',
        oldIsValid: false
      },
      loading: false,
      savingProgress: 0,
      allowSubmit: false,
      isFederatedLoginService: false
    }
  },
  mounted () {
    this.getFederatedLoginService()
    this.isFederatedLoginService = localStorage.isFederatedLoginService
  },
  watch: {
    savingProgress: function (newVal, oldVal) {
      if (newVal === 3) {
        this.getOwnerFederatedLoginService()
        // set message
        // this.message
        this.savingProgress = 0
        this.loading = false
      }
    },
    'googleLoginService.isValid': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    },
    'oneloginLoginService.isValid': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    },
    'appleIdLoginService.isValid': function () {
      this.allowSubmit = this.checkIsChangeConfig()
    }
  },
  methods: {
    checkIsChangeConfig () {
      if (this.googleLoginService.oldIsValid !== this.googleLoginService.isValid) {
        return true
      }
      if (this.oneloginLoginService.oldIsValid !== this.oneloginLoginService.isValid) {
        return true
      }
      if (this.appleIdLoginService.oldIsValid !== this.appleIdLoginService.isValid) {
        return true
      }
      return false
    },
    getFederatedLoginService () {
      this.loading = true
      this.$http.get(Config.FEDERATED_LOGIN_SERVICE_API)
        .then((response) => {
          console.log(response)
          this.federatedLoginServices = response.body.federatedLoginServices
          this.getFederatedLoginServiceId('Onelogin')
          this.getFederatedLoginServiceId('Google')
          this.getFederatedLoginServiceId('Apple')
          this.getOwnerFederatedLoginService()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getFederatedLoginServiceId (providerName) {
      switch (providerName) {
        case 'Google':
          var googleId = this.federatedLoginServices.filter(element => element.name === 'Google')
          if (googleId.length > 0) {
            this.googleLoginService.federatedLoginServiceId = googleId[0].federatedLoginServiceId
          }
          break
        case 'Onelogin':
          var oneloginId = this.federatedLoginServices.filter(element => element.name === 'Onelogin')
          if (oneloginId.length > 0) {
            this.oneloginLoginService.federatedLoginServiceId = oneloginId[0].federatedLoginServiceId
          }
          break
        case 'Apple':
          var appleId = this.federatedLoginServices.filter(element => element.name === 'Apple')
          if (appleId.length > 0) {
            this.appleIdLoginService.federatedLoginServiceId = appleId[0].federatedLoginServiceId
          }
          break
        default:
          break
      }
    },
    getOwnerFederatedLoginService () {
      this.$http.get(Config.OWNER_FEDERATED_LOGIN_SERVICE_API)
        .then((response) => {
          console.log(response)
          this.OwnerFederatedLoginService = response.body.relationsOwnerFederatedLoginService
          this.isGoogleLoginServiceEnable()
          this.isOneloginLoginServiceEnable()
          this.isAppleIdLoginServiceEnable()
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    saveConfig () {
      this.loading = true
      this.saveOnelogin()
      this.saveGoogle()
      this.saveAppleId()
    },
    saveOnelogin () {
      if ((this.oneloginLoginService.oldIsValid !== this.oneloginLoginService.isValid) || this.oneloginLoginService.metadataUrl !== '') {
        if (this.oneloginLoginService.relationId === '') {
          this.submitRelationConfig(this.oneloginLoginService.federatedLoginServiceId, this.oneloginLoginService.isValid, this.oneloginLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(this.oneloginLoginService.relationId, this.oneloginLoginService.isValid, this.oneloginLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },
    saveGoogle () {
      if (this.googleLoginService.oldIsValid !== this.googleLoginService.isValid) {
        if (this.googleLoginService.relationId === '') {
          this.submitRelationConfig(this.googleLoginService.federatedLoginServiceId, this.googleLoginService.isValid, this.googleLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(this.googleLoginService.relationId, this.googleLoginService.isValid, this.googleLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },
    saveAppleId () {
      if (this.appleIdLoginService.oldIsValid !== this.appleIdLoginService.isValid) {
        if (this.appleIdLoginService.relationId === '') {
          this.submitRelationConfig(this.appleIdLoginService.federatedLoginServiceId, this.appleIdLoginService.isValid, this.appleIdLoginService.metadataUrl)
        } else {
          this.updateRelationConfig(this.appleIdLoginService.relationId, this.appleIdLoginService.isValid, this.appleIdLoginService.metadataUrl)
        }
      } else {
        this.savingProgress++
      }
    },

    submitRelationConfig (federatedLoginServiceId, isValid, metadataUrl) {
      var data = {
        federatedLoginServiceId: federatedLoginServiceId,
        isValid: isValid,
        metadataFile: '',
        metadataUrl: metadataUrl
      }
      this.$http.post(Config.OWNER_FEDERATED_LOGIN_SERVICE_API, data)
        .then((response) => {
          console.log(response)
          this.savingProgress++
        }).catch((error) => {
          console.log(error)
          this.savingProgress++
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessage = ''
              } else {
                this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessage = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 500:
              this.errorMessage = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessage = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    updateRelationConfig (relationId, isValid, metadataUrl) {
      var data = {
        metadataUrl: metadataUrl,
        metadataFile: '',
        isValid: isValid

      }
      this.$http.put(Config.OWNER_FEDERATED_LOGIN_SERVICE_API + '/' + relationId, data)
        .then((response) => {
          console.log(response)
          this.savingProgress++
        }).catch((error) => {
          console.log(error)
          this.savingProgress++
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessage = ''
              } else {
                this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessage = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 500:
              this.errorMessage = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessage = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessage = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    isGoogleLoginServiceEnable () {
      var gg = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.googleLoginService.federatedLoginServiceId)
      if (gg.length > 0) {
        this.googleLoginService.isValid = gg[0].isValid
        this.googleLoginService.oldIsValid = gg[0].isValid
        this.googleLoginService.relationId = gg[0].relationId
      }
    },
    isOneloginLoginServiceEnable () {
      var ol = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.oneloginLoginService.federatedLoginServiceId)
      if (ol.length > 0) {
        this.oneloginLoginService.isValid = ol[0].isValid
        this.oneloginLoginService.oldIsValid = ol[0].isValid
        this.oneloginLoginService.relationId = ol[0].relationId
      }
    },
    isAppleIdLoginServiceEnable () {
      var ap = this.OwnerFederatedLoginService.filter(element => element.federatedLoginServiceId === this.appleIdLoginService.federatedLoginServiceId)
      if (ap.length > 0) {
        this.appleIdLoginService.isValid = ap[0].isValid
        this.appleIdLoginService.oldIsValid = ap[0].isValid
        this.appleIdLoginService.relationId = ap[0].relationId
      }
    }
  }
}
</script>
<style>
input[type=checkbox].ace.ace-switch+.lbl::before {
    text-indent: 25px!important;
    content: "\7121\52B9"!important;
}
input[type=checkbox].ace.ace-switch:checked+.lbl::before {
    text-indent: 5px!important;
    content: "\6709\52B9"!important;
}
</style>



// WEBPACK FOOTER //
// src/views/login-service/ExternalLoginServiceSetting.vue